import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import M_logo from '../../assets/logo M.png';


const Settings = () => {

  const [toggleSubList, setToggleSubList] = useState(false)
  const [loggedUser, setLoggedUser] = useState({});

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("login_user"));
    console.log('user : ', user)
    setLoggedUser(user)
  }, [])

  const showHideSubList = async () => {
    setToggleSubList(!toggleSubList);
  }

  document.addEventListener('click', (e) => {
    console.log('e : ', e.target.id)
    if (toggleSubList && e.target.id !== 'avatar') {
      setToggleSubList(false);
    }
  })

  return (
    <div className='profile_container'>
      <div className="profile_header">
        <div className="profile_logo">
          <img src={M_logo} alt="MangasIO_Logo" />
          {/* /../assets/logo M.png */}
          <Link to="/series" className='back'><IoIosArrowBack /></Link>
        </div>
        <div className="profile_search">
          <div className="input">Me {'>'} profile</div>
        </div>
        <div className="profile_avatar">
          <div id='avatar' className="avatar" onClick={showHideSubList} style={toggleSubList ? { border: "1px solid rgb(214, 65, 10)", color: "rgb(214, 65, 10)" } : { border: "none", color: "black" }}>{loggedUser?.username && loggedUser?.username[0]?.toUpperCase()}</div>
          {toggleSubList && <div className="sub_list">
            <Link className="item" to="/logout">Sign out</Link>
          </div>}
        </div>
      </div>
      <div className="profile_content">
        <h2>Settings</h2>
        <div className="profile_settings">
          <ul className="options">
            <li style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }} >Export</li>
          </ul>
          <div className="profile_details">
            <div className="profile_details_content">
              <div className="input_block">
                <label htmlFor="new_role">Document type</label>
                <select>
                  <option value="pdf">PDF</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings